import { Helmet } from 'react-helmet';
import React from 'react';
import { getCurrentLocation } from 'client/helpers/getCurrentLocation';
import { useLocation } from 'react-router-dom';

interface ISEOProps {
  title?: string;
  description?: string;
  image?: string;
  type?: string;
  siteName?: string;
  author?: string;
  twitterUrl?: string;
}
const SEO: React.FC<ISEOProps> = ({
  title = 'Kepler Travel',
  description = `Le Tour Opérateur KEPLER, spécialiste des circuits, voyages à thèmes, 
  week-end et séjours balnéaires sur plusieurs destinations.`,
  // eslint-disable-next-line max-len
  image = 'https://keplertravel.com/favicon/ms-icon-144x144.png',
  type = 'article',
  siteName = 'Kepler Travel',
  author = 'Kepler Travel',
  twitterUrl = 'https://keplertravel.com',
}) => {
  const location = useLocation();
  const url = getCurrentLocation(location.pathname);

  return (
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="robots" content="index,follow" />
      <meta itemProp="name" content={title} />
      <meta itemProp="description" content={description} />
      <meta itemProp="image" content={image} />
      <meta itemProp="picture" content={image} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content={type} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="fr_TN" />
      <meta property="article:author" content={author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterUrl} />
      <meta name="twitter:creator" content={twitterUrl} />
      <meta httpEquiv="Content-Type" content="text/html; charset=Windows-1256" />
      <meta name="google-site-verification" content="1eIs1d1kACsf3rBApWmKzYiXBgj0WEMy2CPUgkt-kro" />
    </Helmet>
  );
};

export default SEO;
